import './style.scss';
import BeneficiaryRow from "../beneficiaryRow";

function BeneficiaryItem({
  itemsDescription,
  beneficiaries,
  backTo = '',
  adminScope = '',
  detailPath = ''
}) {
  return (
    <div className='itemsBeneficiaries-description-container'>
      <div className='description-container'>
        {itemsDescription.length > 0 &&
          itemsDescription.map((itemD, i) => <p key={i}>{itemD.name}</p>)}
      </div>
      {beneficiaries.length > 0 &&
          beneficiaries.map((beneficiary, i) => (
          <BeneficiaryRow
            key={i}
            beneficiary={beneficiary}
            backTo={backTo}
            adminScope={adminScope}
            detailPath={detailPath}
          />
        ))}
    </div>
  );
}
export default BeneficiaryItem;
